export default {
  myClasses: 'My Classes',
  myGrades: 'My Grades',
  goToPDATeacher: 'Go to PDA Teacher',
  goToPAStudent: 'Go to PA Student',
  teachers: 'Teachers',
  teacher: 'Teacher',
  options: 'Menu',
  notesOf: 'Notes of {entity}',
  assessmentPerStudent: 'Assessment per Student',
  assessment: 'Assessment',
  evaluationsOf: '{entity1} of {entity2}',
  assessmentReport: 'Assessment Report',
  progressionOf: 'Progression of {entity}',
  noDataToShow: 'There are no {entity} to show',
  noClassesInPeriod: 'There are no classes taken in this {entity}',
  moduleNotEnabled: 'This module is not enabled for your institution',
  filterBy: 'Filter by {entity}',
  next: 'Next {entity}',
  visibleForEvaluatees: 'Visible for Evaluatees',
  goToThe: 'Go to {entity}',
  inProgress: '{entity} in progress',
  noNext: 'There are no next {entity}',
  finished: '{entity} Finished',
  noEntity: 'There are no {entity}',
  toCorrect: '{entity} to Correct',
  type: 'Type',
  state: 'State',
  goToCorrect: 'Go to correct {entity}',
  entityOfEntity: '{entity1} of {entity2}',
  studentsNotStarted: 'Students who have not started {entity}',
  studentsStartedNotFinished: 'Students who started {entity} but did not finish it',
  studentsDoing: 'Students taking {entity}',
  studentsFinished: 'Students who finished {entity}',
  studentsPublishedGrade: 'Students who have already had their grade published',
  totalStudents: 'Total students',
  noEntityToCorrect: 'There are no {entity} to correct',
  allEvaluationsCorrected: 'There are no {entity} to correct',
  pastClasses: 'Past classes',
  goToEntityProgram: 'Go to {entity}',
  entityOfEntity2: '{entity1} of {entity2}',
  noEntityToShow: 'There are no {entity} to show',
  evaluationsInNext7Days: 'Evaluations in the Next 7 Days',
  noEvaluationsAssignedLast7Days: 'You have no evaluations assigned within the last 7 days.',
  myEntity: 'My {entity}',
  noEntityAssignedCurrentPeriod: 'You do not have any {entity} assigned in the current period.',
  coursesWhereYouAreStudent: 'Courses where you are a student:',
  coursesWhereYouAreProfessor: 'Courses where you are a teacher:',
  level: 'Level',
  evaluations: 'Evaluations',
  gradingCenter: 'Grading Center',
  notes: 'Notes',
  assessmentReport2: 'Assessment Report',
  hide: 'Hide',
  show: 'Show',
  current: 'Current:',
  completed: 'Completed:',
  averageGradesCurrentPeriod: 'Average grades for the current period',
  averageGradesCompletedEntity: 'Average grades of completed {entity}',
  achievements: 'Achievements',
  progressionOfEntity: 'Progression of {entity}',
  entityCompleted: 'Completed {entity}',
  noEntityCompleted: 'You do not have any completed {entity}.',
  coursesWhereYouWereStudent: 'Courses where you were a student:',
  coursesWhereYouWereProfessor: 'Courses where you were a teacher:',
  attentionNotifications: 'Attention/Notifications',
  has: 'You have',
  withoutDate: 'without assigned dates.',
  noNotifications: 'You have no notifications...',
  assignDatesToRemainingEntities: 'Assign dates to remaining {entity}',
  editDates: 'Edit Dates',
  editStartAndEndDate: 'Edit Start Date and End Date',
  announcements: 'Announcements',
  noAnnouncementsLast7Days: 'No announcements from the institution in the last 7 days.',
  messages: 'Messages',
  noMessagesLast7Days: 'No messages in the last 7 days.',
  resources: 'Resources',
  noAssignedResources: 'You have no assigned resources.',
  evaluationHistory: 'Evaluation History {header}',
  note: 'Note',
  evaluation: 'Evaluation',
  scoreObtained: 'Score Obtained',
  weighting: 'Weighting',
  noteColumnDescription: 'This column shows the evaluation grade with respect to {entity}.',
  instrument: 'Instrument',
  noteInstrumentColumnDescription: 'This column shows the instrument grade with respect to the Evaluation.',
  weightingDescription: 'This weighting shows how much this evaluation weighs with respect to {entity}.',
  weightingInstrumentDescription: 'This weighting shows how much the instrument weighs with respect to the evaluation.',
  maxScore: 'Max score',
  noDataToDisplay: 'No data to display',
  currentParentheses: '( Current )',
  completedParentheses: '( Completed )',
  achievementResultsReport: 'Achievement Results Report',
  ceMacro: 'CE Macro',
  statement: 'Statement',
  informationOfThe: 'Information of the {entity}',
  gradesRecordOfThe: 'Grades Record of {entity}',
  downloadExcel: 'Download Excel with grades',
  searchStudents: 'Search Students...',
  viewColumns: 'View columns',
  student: 'Student',
  finalGrade: 'Final Grade',
  pressToUpdateAutomaticScoreColumn: 'Press here to update to automatic score for all in the column.',
  pressToUpdateAutomaticScoreFinalGrade: 'Press here to update to automatic score for all in the final grade column.',
  goToEvaluation: 'Go to Evaluation',
  pressToPublishScore: 'Press here to publish the score of {entity}.',
  pressToWithdrawScore: 'Press here to withdraw the publication of the score of {entity}.',
  studentNotInEvaluatees: '{student} is not among the users who can answer the {entity}.',
  useAutomaticScore: 'Use Automatic Score',
  noDataMatchesSearch: 'No data matches your search.',
  symbologyMeanings: 'Symbology / Meanings',
  saveGradeDescription: 'Saves the entered grade of the {entity} or Evaluation.',
  updateAutomaticScoreDescription: 'Updates the score/grade to the Automatic value.',
  publishScoreDescription: 'Publishes the score of the selected {entity} to students.',
  withdrawPublicationDescription: 'Withdraws the publication of the score of the selected {entity} to students.',
  indicatesAutomaticScore: 'Indicates that the automatic score or grade is being used for {entity} or Evaluation.',
  indicatesStudentCannotAnswer: 'Indicates that the student cannot answer the {entity}.',
  gradeMustBeBetween: 'The grade must be between {min} and {max}',
  validation: 'Validation',
  instrumentPublished: '{entity} published.',
  updatingScoresOf: 'Updating scores of {entity}...',
  problemUpdatingInstruments: 'There was a problem updating the {entity}.',
  updatingEvaluationGrades: 'Updating evaluation grades...',
  problemUpdatingGrades: 'There was a problem updating the grades.',
  updatingFinalGradeOf: 'Updating final grade of {entity}...',
  problemUpdatingFinalGrade: 'There was a problem updating the final grade.',
  gradeUpdated: 'Grade updated.',
  instrumentNotAnswered: 'Instrument not answered',
  automaticScore: 'Automatic score',
  automaticGrade: 'Automatic grade',
  instrumentStartedOn: 'The instrument was started on {date}',
  scoreMustBeBetween: 'The score must be between {min} and {max}',
  noPermissionToViewNextView: 'You do not have permission to view the next view',
  teacherName: 'Teacher Name',
  studentAttentionSchedule: 'Student Attention Schedule',
  coexistenceRulesForThe: 'Coexistence Rules for the',
  filterGradesByPeriod: 'Filter grades by period:',
  currentPeriods: 'Current Periods',
  weightedGrade: 'Weighted Grade',
  feedback: 'Feedback',
  feedbackAbbreviation: 'F...',
  gradeOfThe: 'Grade of the {entity}',
  finalGradeOfThe: 'Final grade of the {entity}',
  weightingOfThe: 'Weighting of the {entity}',
  totalScoreOfThe: 'Total score of the {entity}',
  feedbackOfThe: 'Feedback of the {entity}',
  evaluatorAttachment: 'Evaluator Attachment',
  noEvaluationFoundYet: 'No evaluation found yet.',
  welcomeToPlatformTitle: 'Welcome, {name}!',
  welcomeToPlatformDescription: 'We are glad to have you on the platform. Now you can access academic information and the tools available for your profile.',
  welcomeToPlatformHint: 'From the left side menu you can access the different information and sections available to you.',
}